
import React from "react";
import WizTableForm from "../wizTableForm";
import categoryInfo from "./config-categoryInfo";
import applicationInfo from "./config-applicationInfo";
const categoryConfig = categoryInfo(this, { apiParams: {type: 4, state: 1} });
const applicationConfig = applicationInfo(this, { apiParams: {status: 1} });

const columns = () => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '应用名称',
      name: 'name',
      searchItem: {},
    },
    {
      title: '类型',
      name: 'type',
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '独立应用'},
        {code: 1, codeName: '内嵌应用'},
        {code: 2, codeName: '外链'}
      ]
    },
    {
      title: '分类',
      name: 'categoryId',
      searchItem: {
        ...categoryConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '所属服务',
      name: 'applicationId',
      searchItem: {
        diy: WizTableForm,
        ...applicationConfig,
        selectType: 'radio',
      },
    },
    {
      title: '封面',
      name: 'img',
      tableItem: {
        width:150,
        render: (text, record) => {
          let url = getOssFilePath(record.img)
          // ossFileUtils.getOssFile(
          //   record.img,
          //   record.fileName,
          //   record.fileMimeType,
          //   record.fileSize,
          //   record.fileUri,
          // ).url
          url = record.img ? url : constants.files.sys_img_loadingFailed;
          return <div style={{display: 'flex', 'justify-content': 'flex-start', marginRight: 0,}}>
            <div>
              <img height={50} width={50} src={url}/>
            </div>
          </div>
        }
      }
    },
    {
      title: '应用名称',
      name: 'name',
      tableItem: {width:150},
    },
    {
      title: '类型',
      name: 'type',
      tableItem: {width:150},
      dict: [
        {code: 0, codeName: '独立应用'},
        {code: 1, codeName: '内嵌应用'},
        {code: 2, codeName: '外链'}
      ]
    },
    {
      title: '适用终端',
      name: 'adapterNames',
      tableItem: {width:150}
    },
    {
      title: '分类',
      name: 'categoryName',
      tableItem: {width:150},
    },
    {
      title: '所属服务',
      name: 'applicationName',
      tableItem: {width:150},
    },
    {
      title: '适用终端',
      name: 'adaptersList',
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: 'PC'},
        {code: 1, codeName: 'APP'},
        // {code: 2, codeName: '企业号'},
        // {code: 3, codeName: '小程序'},
        {code: 4, codeName: '凯迪拉克IQ'},
        {code: 5, codeName: '雪佛兰企微'},
        {code: 6, codeName: '别克企微'},
        {code: 7, codeName: '凯迪拉克企微'},
      ]
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'applicationColumn/list',
    ...api
  }
}

const applicationColumn = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default applicationColumn
